import React, { createContext, FC, useCallback, useState } from 'react';
import ConfirmDialog from 'src/components/ConfirmDialog';
import type { ConfirmContextType, DialogSettings } from '../types/confirm';

export const ConfirmContext = createContext<ConfirmContextType | null>(null);

export const defaultDialogState: DialogSettings = {
  title: 'Are you sure?',
  content: 'Do you really wanna do this action?',
  cancelButtonText: 'Cancel',
  confirmButtonText: 'Yes',
  hasNoConfirmButton: false,
  hasNoCancelButton: false,
  width: 'auto',
  cancelColor: 'info',
  className: '',
  confirmColor: 'info',
  closeIcon: true,
  onClose: undefined,
};

type Props = {
  children: React.ReactNode;
};

export const ConfirmContextProvider: FC<Props> = ({ children }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [dialogSettings, setDialogSettings] = useState<DialogSettings>(defaultDialogState);

  const setCurrentDialogSettings = useCallback((settings: Partial<DialogSettings>) => {
    setDialogSettings({ ...defaultDialogState, ...settings });
  }, []);

  const setDefaultDialogSettings = useCallback(() => {
    setDialogSettings(defaultDialogState);
  }, []);

  return (
    <ConfirmContext.Provider
      value={{ open, setOpen, dialogSettings, setCurrentDialogSettings, setDefaultDialogSettings }}
    >
      <ConfirmDialog />
      {children}
    </ConfirmContext.Provider>
  );
};
